export const FIELD_CATEGORIES = {
    RECIPIENT_MAIN_INFO: 'recipient_main_info',
    SENDER_ADDITIONAL_INFO: 'sender_additional_info',
    RECIPIENT_ADDITIONAL_INFO: 'recipient_additional_info',
    TRANSFER_ADDITIONAL_INFO: 'transfer_additional_info',
} as const;

export type FieldCategoryKey = keyof typeof FIELD_CATEGORIES;
export type FieldCategoryValue = (typeof FIELD_CATEGORIES)[FieldCategoryKey];

export const { RECIPIENT_MAIN_INFO, SENDER_ADDITIONAL_INFO, RECIPIENT_ADDITIONAL_INFO, TRANSFER_ADDITIONAL_INFO } = FIELD_CATEGORIES;
